import React from 'react';
import Header from './Header';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <Header />
      <div className="about-content">
        <h1>About ResoREP</h1>
        <p>
          ResoREP is dedicated to providing students with a comprehensive repository of past papers and valuable study resources. 
          Our mission is to empower learners by making exam materials and supportive content easily accessible and well-organized.
        </p>
      </div>
    </div>
  );
};

export default About; 